import { Box, styled } from "@mui/material";
import { motion } from "framer-motion";

export const HoverScaleBackground = styled(motion.div)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: theme.palette.dsSurface.v100,
  transition: "background-color 0.2s ease",

  "&:hover": {
    backgroundColor: theme.palette.dsSurface.v200,
  },
}));

export const HoverScaleContent = styled(Box)({
  zIndex: 1,
  pointerEvents: "none",
});

export const hoverScaleProps = {
  whileHover: { scale: 1.05 },
  whileTap: { scale: 0.95 },
  transition: { type: "spring", stiffness: 300, damping: 15, duration: 0.1 },
};
